// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetIntegrationCallsRequestModel from '../../model/get-integration-calls-request-model';
import GetIntegrationCallsRequestDTO from '../dto/get-integration-calls-request-dto';
import dtoSchema from '../schemas/get-integration-calls-request-schema';

export default abstract class GetIntegrationCallsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetIntegrationCallsRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.dateFrom = data.dateFrom;
      this.dateTo = data.dateTo;
      this.integrationTaskId = data.integrationTaskId;
      this.integrationStatusId = data.integrationStatusId;
      this.correlationId = data.correlationId;
      this.appTransactionId = data.appTransactionId;
      this.appUserId = data.appUserId;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {date-time}
  */
  dateFrom?: string;
  /**
  * @type {date-time}
  */
  dateTo?: string;
  /**
  * @type {int64}
  */
  integrationTaskId?: number;
  /**
  * @type {int64}
  */
  integrationStatusId?: number;
  /**
  */
  correlationId?: string;
  /**
  */
  appTransactionId?: string;
  /**
  * @type {int64}
  */
  appUserId?: number;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetIntegrationCallsRequestDTO>): GetIntegrationCallsRequestModel;
  static toModel(dto: DeepPartial<GetIntegrationCallsRequestDTO> | undefined | null): GetIntegrationCallsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetIntegrationCallsRequestDTO> | undefined | null): GetIntegrationCallsRequestModel | undefined {
    return dto ? new GetIntegrationCallsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetIntegrationCallsRequestModel> | GetIntegrationCallsRequestModel): GetIntegrationCallsRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      dateFrom: unwrapped.dateFrom,
      dateTo: unwrapped.dateTo,
      integrationTaskId: unwrapped.integrationTaskId,
      integrationStatusId: unwrapped.integrationStatusId,
      correlationId: unwrapped.correlationId,
      appTransactionId: unwrapped.appTransactionId,
      appUserId: unwrapped.appUserId,
      searchCriteria: unwrapped.searchCriteria,
    } as GetIntegrationCallsRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetIntegrationCallsRequestModel, can not map to GetIntegrationCallsRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
